import React from 'react';
import { motion } from 'framer-motion';
import { GlobeIcon } from 'lucide-react';
export function LanguageSelectSlide({
  onSelect
}: {
  onSelect: (lang: string) => void;
}) {
  const languages = [{
    code: 'en',
    label: 'English',
    native: 'English',
    greeting: 'Welcome to your breast clinic intake',
    dir: 'ltr' as const
  }, {
    code: 'ur',
    label: 'Urdu',
    native: 'اردو',
    greeting: 'بریسٹ کلینک انٹیک میں خوش آمدید',
    dir: 'rtl' as const
  }, {
    code: 'ar',
    label: 'Arabic',
    native: 'العربية',
    greeting: 'مرحباً بكم في استقبال عيادة الثدي',
    dir: 'rtl' as const
  }];
  return <div className="flex flex-col h-full relative z-10 bg-white justify-between overflow-y-auto no-scrollbar" data-id="element-424">
      <div className="flex-1 flex flex-col items-center w-full" data-id="element-425">
        {/* Logo */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5
      }} className="w-full px-6 pt-8 pb-4 flex justify-center" data-id="element-426">
          <img src="https://cdn.magicpatterns.com/uploads/eWJnHd6KU81M388b5WU5VJ/Screenshot_2026-03-10_at_18.49.55.png" alt="NHS Imperial College Healthcare" className="h-14 object-contain" data-id="element-427" />
        </motion.div>

        <div className="px-6 max-w-sm mx-auto w-full flex-1 flex flex-col justify-center" data-id="element-428">
          {/* Globe icon */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.2,
          type: 'spring',
          stiffness: 200,
          damping: 20
        }} className="flex justify-center mb-6" data-id="element-429">
            <div className="w-16 h-16 bg-nhs-blue/10 rounded-full flex items-center justify-center" data-id="element-430">
              <GlobeIcon className="w-8 h-8 text-nhs-blue" data-id="element-431" />
            </div>
          </motion.div>

          {/* Title in all languages */}
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="text-center mb-10" data-id="element-432">
            <h1 className="text-2xl font-semibold text-slate-900 mb-2" data-id="element-433">
              Choose your language
            </h1>
            <p className="text-lg text-slate-500 font-medium" dir="rtl" data-id="element-434">
              اپنی زبان منتخب کریں
            </p>
            <p className="text-lg text-slate-500 font-medium" dir="rtl" data-id="element-435">
              اختر لغتك
            </p>
          </motion.div>

          {/* Language buttons */}
          <div className="space-y-3" data-id="element-436">
            {languages.map((lang, i) => <motion.button key={lang.code} initial={{
            opacity: 0,
            y: 15
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4 + i * 0.1
          }} onClick={() => onSelect(lang.code)} className="w-full p-5 rounded-xl border-2 border-slate-200 bg-white shadow-sm hover:border-nhs-blue hover:shadow-md transition-all duration-200 active:scale-[0.98] group" data-id="element-437">
                <div className="flex items-center justify-between" data-id="element-438">
                  <div className="flex items-center space-x-4" data-id="element-439">
                    <div className="w-10 h-10 bg-nhs-blue/10 rounded-lg flex items-center justify-center group-hover:bg-nhs-blue/20 transition-colors" data-id="element-440">
                      <span className="text-nhs-blue font-bold text-sm uppercase" data-id="element-441">
                        {lang.code}
                      </span>
                    </div>
                    <div className="text-left" data-id="element-442">
                      <span className="text-slate-900 font-semibold text-lg block leading-tight" data-id="element-443">
                        {lang.native}
                      </span>
                      {lang.code !== 'en' && <span className="text-slate-400 text-sm" data-id="element-444">
                          {lang.label}
                        </span>}
                    </div>
                  </div>
                  <div className="text-slate-300 group-hover:text-nhs-blue transition-colors" data-id="element-445">
                    <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-446">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" data-id="element-447" />
                    </svg>
                  </div>
                </div>
              </motion.button>)}
          </div>
        </div>
      </div>

      {/* Footer */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.8
    }} className="px-6 pb-8 pt-4 text-center" data-id="element-448">
        <p className="text-xs text-slate-400" data-id="element-449">
          Imperial College Healthcare NHS Trust
        </p>
      </motion.div>
    </div>;
}